// every ipc channel name in one place so they are easy to search

export const CHANNELS = {
  settingsGet: "settings:get",
  settingsSave: "settings:save",
  secretsStatus: "secrets:status",
  secretsSet: "secrets:set",

  tasksList: "tasks:list",
  tasksBoards: "tasks:boards",
  tasksUpdated: "tasks:updated",
  tasksStatus: "tasks:status",
  tasksHide: "tasks:hide",
  tasksView: "tasks:view",
  tasksPick: "tasks:pick",
  tasksBoardAdd: "tasks:board-add",
  tasksBoardRename: "tasks:board-rename",
  tasksBoardRemove: "tasks:board-remove",
  tasksPlace: "tasks:place",
  planeConnect: "plane:connect",
  chixAdd: "chix:add",
  chixEdit: "chix:edit",
  chixComplete: "chix:complete",

  notesList: "notes:list",
  notesSave: "notes:save",
  notesRemove: "notes:remove",
  notesAppendInbox: "notes:append-inbox",
  notesUpdated: "notes:updated",

  // what each person shares with whom, and read only looks at what others share with you
  sharesGet: "shares:get",
  sharesSet: "shares:set",
  sharesUpdated: "shares:updated",
  sharedRead: "shared:read",
  sharedUpdated: "shared:updated",

  referencesList: "references:list",
  referencesTag: "references:tag",
  referencesRemove: "references:remove",
  referencesImport: "references:import",
  referencesRetry: "references:retry",
  referencesIndex: "references:index",
  referencesIndexOne: "references:index-one",
  referencesReindex: "references:reindex",
  referencesUpdated: "references:updated",

  assistantSend: "assistant:send",
  assistantReset: "assistant:reset",
  assistantOpenMemory: "assistant:open-memory",
  assistantChunk: "assistant:chunk",
  assistantDone: "assistant:done",

  tabsShow: "tabs:show",
  tabsHide: "tabs:hide",
  tabsReload: "tabs:reload",
  tabsHome: "tabs:home",

  statsList: "stats:list",
  statsUpdated: "stats:updated",

  calendarList: "calendar:list",
  calendarAdd: "calendar:add",
  calendarRemove: "calendar:remove",
  calendarUpdated: "calendar:updated",
  calendarLinksList: "calendar:links-list",
  calendarLinksAdd: "calendar:links-add",
  calendarLinksRemove: "calendar:links-remove",
  calendarLinksSync: "calendar:links-sync",
  calendarLinksSetVisible: "calendar:links-set-visible",

  remindersList: "reminders:list",
  remindersAdd: "reminders:add",
  remindersRemove: "reminders:remove",
  remindersUpdated: "reminders:updated",

  routinesList: "routines:list",
  routinesSave: "routines:save",
  routinesRemove: "routines:remove",
  routinesDone: "routines:done",
  routinesUpdated: "routines:updated",
  routinesDue: "routines:due",

  goalsList: "goals:list",
  goalsSave: "goals:save",
  goalsStep: "goals:step",
  goalsProgress: "goals:progress",
  goalsDone: "goals:done",
  goalsRemove: "goals:remove",
  goalsUpdated: "goals:updated",

  studioGet: "studio:get",
  studioAddColor: "studio:add-color",
  studioRemoveColor: "studio:remove-color",
  studioAddPrompt: "studio:add-prompt",
  studioRemovePrompt: "studio:remove-prompt",
  studioAddJob: "studio:add-job",
  studioRemoveJob: "studio:remove-job",
  studioView: "studio:view",
  studioSaveType: "studio:save-type",
  studioRemoveType: "studio:remove-type",
  studioStarterTypes: "studio:starter-types",
  studioAddPayment: "studio:add-payment",
  studioRemovePayment: "studio:remove-payment",
  studioAddCredit: "studio:add-credit",
  studioRemoveCredit: "studio:remove-credit",
  studioSaveClient: "studio:save-client",
  studioSaveClientOc: "studio:save-client-oc",
  studioRemoveClientOc: "studio:remove-client-oc",
  studioSuggestRefs: "studio:suggest-refs",
  studioDescribeOc: "studio:describe-oc",
  studioUpdated: "studio:updated",

  budgetGet: "budget:get",
  budgetSave: "budget:save",
  budgetRemove: "budget:remove",
  budgetPay: "budget:pay",
  budgetStop: "budget:stop",
  budgetUpdated: "budget:updated",
  budgetSharedSave: "budget:shared-save",
  budgetSharedRemove: "budget:shared-remove",
  budgetSharedPay: "budget:shared-pay",
  budgetSharedStop: "budget:shared-stop",

  mapsConfig: "maps:config",
  mapsNearby: "maps:nearby",
  mapsRoute: "maps:route",
  mapsGet: "maps:get",
  mapsSavePlace: "maps:save-place",
  mapsRemovePlace: "maps:remove-place",
  mapsSaveRoute: "maps:save-route",
  mapsRemoveRoute: "maps:remove-route",
  mapsUpdated: "maps:updated",

  rouletteGet: "roulette:get",
  rouletteSave: "roulette:save",
  rouletteRemove: "roulette:remove",
  rouletteSpun: "roulette:spun",
  rouletteUpdated: "roulette:updated",

  ocsList: "ocs:list",
  ocsSave: "ocs:save",
  ocsRemove: "ocs:remove",
  ocsImportZirk: "ocs:import-zirk",
  ocsImportDiscord: "ocs:import-discord",
  ocsMerge: "ocs:merge",
  ocsRemovePicture: "ocs:remove-picture",
  ocsSetPicture: "ocs:set-picture",
  ocsOwn: "ocs:own",
  ocsUpdated: "ocs:updated",
  ocsIndex: "ocs:index",
  ocsIndexStatus: "ocs:index-status",
  ocsIndexUpdated: "ocs:index-updated",

  journalAdd: "journal:add",
  navOrderSave: "nav:order",

  serverBots: "server:bots",
  serverOverview: "server:overview",
  serverAction: "server:action",
  serverJournal: "server:journal",
  serverCaddy: "server:caddy",

  logsList: "logs:list",
  logsClear: "logs:clear",
  logsEntry: "logs:entry",

  claudeUsage: "claude:usage",

  // everyone's own chrome extension token
  extensionTokenGet: "extension-token:get",
  extensionTokenReset: "extension-token:reset",

  // the people dashboard, fractal only
  peopleList: "people:list",
  peopleAdd: "people:add",
  peopleSave: "people:save",
  peopleRemove: "people:remove",

  // profiles and alters, everyone's own. the service checks who owns what
  profileGet: "profile:get",
  profileSave: "profile:save",
  profileAvatar: "profile:avatar",
  altersCreate: "alters:create",
  altersRemove: "alters:remove",
  altersOwner: "alters:owner",

  gesturePick: "gesture:pick",
  japaneseToday: "japanese:today",
  japaneseAnswer: "japanese:answer",
  japaneseSettings: "japanese:settings",
  japaneseUpdated: "japanese:updated",
  referencesCaption: "references:caption",

  printersList: "printers:list",
  scansList: "scans:list",
  scansInbox: "scans:inbox",
  scansCapture: "scans:capture",
  scansImport: "scans:import",
  scansRead: "scans:read",
  scansSave: "scans:save",
  scansRemove: "scans:remove",
  scansUpdated: "scans:updated",

  doodlesList: "doodles:list",
  doodlesAdd: "doodles:add",
  doodlesSave: "doodles:save",
  doodlesRemove: "doodles:remove",
  doodlesCount: "doodles:count",
  doodlesUpdated: "doodles:updated",

  tierlistsList: "tierlists:list",
  tierlistsGet: "tierlists:get",
  tierlistsCreate: "tierlists:create",
  tierlistsSave: "tierlists:save",
  tierlistsRemove: "tierlists:remove",
  tierlistsImages: "tierlists:images",
  tierlistsShare: "tierlists:share",
  tierlistsUpdated: "tierlists:updated",

  trackerList: "tracker:list",
  trackerGet: "tracker:get",
  trackerCreate: "tracker:create",
  trackerSave: "tracker:save",
  trackerRemove: "tracker:remove",
  trackerUpdated: "tracker:updated",

  musicLibrary: "music:library",
  musicUpload: "music:upload",
  musicYoutube: "music:youtube",
  musicJobs: "music:jobs",
  musicTools: "music:tools",
  musicSaveTrack: "music:save-track",
  musicRemoveTrack: "music:remove-track",
  musicSavePlaylist: "music:save-playlist",
  musicRemovePlaylist: "music:remove-playlist",
  musicUpdated: "music:updated",


  // whiteboards, private and shared. ops are the live strokes and layer changes
  boardsList: "boards:list",
  boardsGet: "boards:get",
  boardsCreate: "boards:create",
  boardsApply: "boards:apply",
  boardsThumb: "boards:thumb",
  boardsRemove: "boards:remove",
  boardsOps: "boards:ops",
  boardsPresence: "boards:presence",
  boardsUpdated: "boards:updated",
  boardList: "board:list",
  boardPost: "board:post",
  boardEdit: "board:edit",
  boardRemove: "board:remove",
  boardUpdated: "board:updated",

  // achievements, points, medals and the leaderboard, the drawing challenge, and suggestions for chix
  awardsGet: "awards:get",
  awardsBoard: "awards:board",
  awardsClean: "awards:clean",
  awardsEvent: "awards:event",
  awardsVisible: "awards:visible",
  awardsUpdated: "awards:updated",
  awardsUnlocked: "awards:unlocked",
  challengeGet: "challenge:get",
  challengeAct: "challenge:act",
  feedList: "feed:list",
  feedCheer: "feed:cheer",
  feedRemove: "feed:remove",
  feedUpdated: "feed:updated",
  feedPost: "feed:post",
  feedEdit: "feed:edit",
  feedComment: "feed:comment",
  feedCommentRemove: "feed:comment-remove",
  suggestionsList: "suggestions:list",
  suggestionsPost: "suggestions:post",
  suggestionsVote: "suggestions:vote",
  suggestionsStatus: "suggestions:status",
  suggestionsRemove: "suggestions:remove",
  suggestionsUpdated: "suggestions:updated",
  pollGet: "poll:get",
  pollVote: "poll:vote",
  pollUpdated: "poll:updated",

  // home's message of the day and studio's tip line, an art tip from a random minipi
  minipiMotd: "minipi:motd",

  openExternal: "app:open-external",
  navigate: "app:navigate",
  quickCapture: "app:quick-capture",
  cloudInfo: "cloud:info",
  // the desktop app's tray and taskbar follow the language the renderer loaded
  appLanguage: "app:language"
} as const;

export const CHANNEL_NAMES: string[] = Object.values(CHANNELS);
